export const drilldownConfig = "";

export const chartTitleFontFamily = "Montserrat,Helvetica Neue,Arial,sans-serif";
export const chartFontFamily = "Roboto,Montserrat,Helvetica Neue,Arial,sans-serif";
export const chartFontColor = '#6c757d';
export const chartLineColor = '#dadfe7';

export const chartLabelFontSize = 12;

export const chartTitleStyleParams = {
    fontFamily: chartTitleFontFamily,
    fontSize: 14,
    fontWeight: 500,
    padding: 10,
}

// properties that will be applied to all CanvasJS charts
export const commonChartProps = {
    animationEnabled: true,
    legend: {
        fontSize: 12,
        fontWeight: 500,
        fontColor: chartFontColor,
        fontFamily: chartFontFamily
    },
    toolTip: {
        fontSize: 12,
        fontWeight: 500,
        fontColor: chartFontColor,
        fontFamily: chartFontFamily
    }
}
export const inventoryDataPointColorSet = [
    "#f84747",  //red, Aged
    "#ff9920",  //orange, Obsolete
    "#6554c0",  //purple, Slow Moving
    "#429edb",  //blue, Avg Moving
    "#4bcd96",  //green, Fast Moving
    "#ff5722",
    "#673ab7",
    "#f44336"
]
export const profitDataPointColorSet = [
    "#429edb",
    "#4bcd96",
    "#fc872e",
    "#728691",
    "#9c27b0",
    "#ff5722",
    "#673ab7",
    "#f44336"
]
export const salesByProductGroupColorSet = [
    "#6554c0",
    "#4bcd96",
    "#fc872e",
    "#728691",
    "#9c27b0",
    "#ff5722",
    "#673ab7",
    "#f44336"
]

export const emptyDataset = {
    "dataSeriesLabel": [],
    "data": []
};

export function isEmptyDataset(obj) {
    return !obj || !(obj.data && obj.data.length > 0);

}


// WEBPACK FOOTER //
// ./src/components/utils/ChartHelpers.js